import { Button } from './Button';
import Graphics = PIXI.Graphics;
import Point = PIXI.Point;
import { createSprite, getRandomColor, resizeTextByReference } from '../../../utils/GameEngine';
import { TextStyles } from '../../../utils/TextStyles';

export abstract class IconButton extends Button {
    protected textSpace: Graphics;
    protected iconTexture: string;
    protected icon: PIXI.Sprite;
    protected iconScale: number = 0.5;

    protected constructor(
        label: string,
        callback?: () => any,
        bgTexture: string = 'yellow_button_small@2x',
        defaultAnimations: boolean = true,
        appearAnimation: boolean = true,
        scale: number = 0.5,
        protected maxFontSize: number = 72,
        disable: boolean = false,
    ) {
        super(
            bgTexture,
            callback,
            label,
            defaultAnimations,
            appearAnimation,
            scale,
            maxFontSize,
            disable);
    }

    protected initProperties(): void {
        super.initProperties();
        this.labelStyle = TextStyles.smallTextBlack.clone();
    }

    protected drawLayout(): void {
        super.drawLayout();
        this.icon = createSprite(this.iconTexture, this);
        this.icon.anchor.set(0.5, 0.5);
        this.icon.scale.set(this.iconScale, this.iconScale);
        this.icon.position.set(this.icon.width / 2, this.defaultSkin.height / 2);

        this.textSpace = new Graphics();
        this.textSpace.beginFill(getRandomColor());
        this.textSpace.drawRect(
            this.icon.x + this.icon.width / 2 + 5,
            5,
            this.defaultSkin.width - (this.icon.x + this.icon.width / 2 + 15),
            this.defaultSkin.height - 10
        );
        // this.textSpace.alpha = 0.3;
        // this.addChild(this.textSpace);
        this.textSpace.endFill();
    }

    public updateLabel(text: string): void {
        super.updateLabel(text);
        this.label.style.fontSize = this.labelStyle.fontSize;
        this.label.style.strokeThickness = this.labelStyle.strokeThickness;
        resizeTextByReference(this.label, this.textSpace, 0);
        this.label.style.align = 'left';
        this.label.anchor = new Point(0, 0.5);
        this.label.x = this.icon.x + this.icon.width / 2 + 5;
        this.label.y = this.defaultSkin.height / 2;
    }
}